import Icon from '@material-ui/icons/Assignment';
import Show from './SupplyReceiptShow';

export default {
    show: Show,
    icon: Icon,
};
